

const attrs = {

	price: {
		label: 'Price',			order: 'min',	type: '$'	},

	screenSize: { label: 'Screen size',	order: 'max',	type: '"' },
	
	resolutionV: { 
		label: 'Resolution',		order: 'max', type: 'px' },

	aspectRatioFloat: { 
		label: 'Aspect ratio',	order: 'max',	type: ''  },

	refreshRate: { 
		label: 'Refresh rate',	order: 'max', type: 'Hz' },
	
	responseTime: { 
		label: 'Response time', order: 'min', type: 'ms' },
	
	brightness: { 
		label: 'Brightness',		order: 'max', type: 'cd/m²' },
	
	pixelDensity: { 
		label: 'Pixel density', order: 'max', type: 'PPI' },
	
	contrast: { 
		label: 'Contrast',		order: 'max', type: ':1' },
}


const attrArr = Object.entries(attrs).map(([id, attr]) => ({
	id,
	...attr
}))

// const compareAttr = [

// 	{ id: 'price', label: "Price", type: '$' },
// 	{ id: 'screenSize', label: "Screen size", type: '"' },
// 	{ id: 'curveRadius', label: "Curve radius", type: '' },
// 	{ id: 'resolutionV', label: "Vertical resolution", type: 'px' },
// 	{ id: 'resolutionH', label: "Horizontal resolution", type: 'px' },
// 	{ id: 'aspectRatio', label: "Aspect ratio", type: '' },
// 	// { id: 'resolution', label: "Resolution", 
// 	// 	compare: (a, b) => (a.resolutionV > b.resolutionV) }

// ]


export { attrArr }

export default attrs
